import { Injectable } from '@angular/core';
import {
  NewPartnership,
  Partnership,
  PartnershipFilterModel,
  PartnershipsResponseModel,
  PartnershipTypesResponseModel,
} from '@core/models';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PartnershipService {
  constructor(private readonly apiService: ApiService) {}

  getPartnerships(filter: PartnershipFilterModel): Observable<PartnershipsResponseModel> {
    return this.apiService.get('/partners/partnerships/', filter as any);
  }

  getPartnership(partnershipOid: string): Observable<Partnership> {
    return this.apiService.get(`/partners/partnerships/${partnershipOid}`);
  }

  getPartnershipTypes(): Observable<PartnershipTypesResponseModel> {
    return this.apiService.get('/partners/partnerships/partnership-types');
  }

  createPartnership(payload: NewPartnership): Observable<Partnership> {
    return this.apiService.post('/partners/partnerships/', payload);
  }

  acceptPartnership(partnershipOid: string): Observable<Partnership> {
    return this.apiService.put(`/partners/partnerships/${partnershipOid}/accept`);
  }

  declinePartnership(partnershipOid: string): Observable<Partnership> {
    return this.apiService.put(`/partners/partnerships/${partnershipOid}/decline`);
  }

  extendPartnership(partnershipOid: string, reviewDueDate: string): Observable<Partnership> {
    return this.apiService.put(`/partners/partnerships/${partnershipOid}/extend`, {
      reviewDueDate,
    });
  }

  revokePartnership(partnershipOid: string): Observable<Partnership> {
    return this.apiService.put(`/partners/partnerships/${partnershipOid}/revoke`);
  }

  addInstallationGroupToPartnership(
    partnershipOid: string,
    installationGroupOid: string,
  ): Observable<any> {
    return this.apiService.post(
      `/partners/partnerships/${partnershipOid}/installation-groups`,
      { installationGroupOid },
    );
  }

  removeInstallationGroupFromPartnership(
    partnershipOid: string,
    installationGroupOid: string,
  ): Observable<any> {
    return this.apiService.delete(
      `/partners/partnerships/${partnershipOid}/installation-groups/${installationGroupOid}`,
    );
  }
}
